import React from 'react';
// Data
import { favoriteSessionsArray } from '../../utils/data/ServicesData';
// Images
import FullMainImage from '../../assets/images/main/mistress-diva-pro-dominatrix-and-femdom-in-red-blowing-pin-wheel.webp';
// Constants
import { CONTACT_PAGE_URL } from '../../utils/Constants';

export default function FavouriteServices() {
  return (
    <section className='grid w-full border-b-2 border-solid border-colour7 pb-8 lg:pb-16 bg-colour4 full_shadow_black_invert pointer-events-auto'>
      <div className='grid gap-6 md:gap-10 lg:gap-12 px-6 sm:px-10 md:px-24'>
        {/* Header */}
        <section className='grid text-center pt-8 lg:pt-12'>
          <div>
            <h4 className='text-3xl font-argesta'>A few of My favourites...</h4>
            <h5>
              “I rule to quench My Dominant urges…you are here to satisfy them”
            </h5>
          </div>
        </section>

        {/* Grid Layout */}
        <section className='grid'>
          <section className='grid'>
            <div className='grid gap-6 lg:grid-cols-[1fr_auto_1fr]'>
              {/* Left Column */}
              <div className='grid my-auto gap-y-6'>
                {favoriteSessionsArray.slice(0, 3).map((session, index) => (
                  <SessionCard
                    key={session.title}
                    session={session}
                    index={index}
                  />
                ))}
              </div>

              {/* Center Image (Only on large screens) */}
              <div className='flex items-center'>
                <img
                  src={FullMainImage}
                  alt='Mistress Diva'
                  className='w-64 rounded-lg shadow-lg mx-auto'
                />
              </div>

              {/* Right Column */}
              <div className='grid my-auto gap-y-6'>
                {favoriteSessionsArray.slice(3, 6).map((session, index) => (
                  <SessionCard
                    key={session.title}
                    session={session}
                    index={index + 3}
                  />
                ))}
              </div>
            </div>
          </section>

          {/* Find Out More Button */}
          <section className='grid'>
            <div className='mt-8 flex justify-center'>
              <a href={CONTACT_PAGE_URL} className=''>
                Find Out More
              </a>
            </div>
          </section>
        </section>
      </div>
    </section>
  );
}

// Individual Session Card
const SessionCard = ({ session, index }) => {
  const borderColor = index % 2 === 0 ? 'border-colour9 ' : 'border-colour9';

  return (
    <article
      className={`group grid gap-1 h-fit text-colour1 border-solid ${borderColor} px-4 py-2 shadow-colour1/80 text-center`}
    >
      <div>
        <h3 className='text-2xl tracking-widest font-argesta cursor-pointer'>
          {session.title}
        </h3>
      </div>
      <div className=' h-fit shadow-cardShadowBold shadow-colour4/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300'>
        <p className=''>
          {session.description}
        </p>
      </div>
    </article>
  );
};
